document.addEventListener('alpine:init', () => {
    Alpine.store('faqGlobal', {
        selectedTerm: '',
        searchSubmitted: false,
    });
}); 
